export enum RECOVERY_FORM_MODES {
    RECOVERY = 'RECOVERY',
    CHANGE = 'CHANGE'
}